'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

import '@/components/About/Organisms/IndexContent/IndexContent.scss'

const IndexContentLogic = dynamic(() => import('@/components/About/Organisms/IndexContent/IndexContentLogic'), {
  ssr: true,
})

// @ts-ignore
const IndexContent: FC = () => {
  return (
    <>
      <IndexContentLogic />
    </>
  )
}

export default IndexContent
